import { render } from "./AutoVerificationResults.vue?vue&type=template&id=167eef12"
import script from "./AutoVerificationResults.vue?vue&type=script&lang=js"
export * from "./AutoVerificationResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__